import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import LoadingComponent from '../CommonComponent/LoadingComponent';
import AccessControlComponent from '../RouteComponents/AccessControlComponent';
import { UserEnum } from '../../utils/app-common';
import {
  HandoverDetailComponentLoadable,
  HandoverFormComponentLoadable,
  HandoverTableComponentLoadable,
  AoneWaybillIntegrationTableComponentLoadable
} from './index';
import { PodDispatchComponentLoadable } from '../PodDispatch';
import { ProofOfDeliveryTableComponentLoadable } from '../ProofOfDelivery';

/**
 * A-One module sub-routes.
 *
 * Mounted at /a-one/* inside AppRoutes → the paths below are
 * relative to that prefix (e.g. "handover" resolves to /a-one/handover).
 */
const AOneRoutes = () => {
  const handoverAccess = [
    UserEnum.ADMIN,
    UserEnum.MANAGER,
    UserEnum.OPS_MANAGER,
    UserEnum.OPERATION_SUPERVISOR,
    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
    UserEnum.OPERATION_CS_SUPERVISOR,
    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
    UserEnum.OPERATION_STAFF,
    UserEnum.FLEET_SUPERVISOR,
    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
  ];

  return (
    <Routes>
      {/* Handover list */}
      <Route
        path="handover"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={handoverAccess} isRoute>
              <HandoverTableComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />

      {/* Create handover */}
      <Route
        path="handover/create"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={handoverAccess} isRoute>
              <HandoverFormComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />

      {/* Edit handover */}
      <Route
        path="handover/edit/:id"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={handoverAccess} isRoute>
              <HandoverFormComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />

      {/* Handover detail */}
      <Route
        path="handover/:id"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={handoverAccess} isRoute>
              <HandoverDetailComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />

      {/* POD Upload */}
      <Route
        path="pod-upload"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={[UserEnum.MANAGER, UserEnum.A_ONE]} isRoute>
              <ProofOfDeliveryTableComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />

      {/* POD Dispatch */}
      <Route
        path="pod-dispatch"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={[UserEnum.MANAGER, UserEnum.A_ONE]} isRoute>
              <PodDispatchComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />

      {/* A-One Waybills */}
      <Route
        path="a-one-waybills"
        element={
          <Suspense fallback={<LoadingComponent />}>
            <AccessControlComponent access={handoverAccess} isRoute>
              <AoneWaybillIntegrationTableComponentLoadable />
            </AccessControlComponent>
          </Suspense>
        }
      />


    </Routes>
  );
};

export default AOneRoutes;
